module.exports = __webpack_public_path__ + "static/img/40006 (1).1de3e85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40006 (1).jpg
// module id = n5oU
// module chunks = 14